import env from '@/utils/env'

/** 真实的接口地址 */
export const REAL_API_URL = 'https://api.yinnho.cn/api.php'

/** 代理的接口地址 */
export const PROXY_API_URL = '/api'

/** 接口地址，正常情况下使用这个 */
export const API_URL = env.dev ? PROXY_API_URL : REAL_API_URL

/** 请求字段中的无效值 */
export const FALSY_VALYES = [undefined, null, '']

/** 请求字段的 登录信息字段 */
export const TOKEN_KEY = 'msid'

/** 接口名称识别参数，拼接在接口后面 */
export const API_NAME_PARAM_KEY = 'do'
